

import mixx from "../../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  name: "terminales",
  data() {
    return {
      loading: false,
      load_ter: 0,
      selected_ter: 0,
      listado_terminales: [
        {
          ter: "--",
          comercio: "--",
          trx: {
            Dev: true,
            compra: false,
            compraEC: false,
            anula: false
          },
          tktImp: {
            cliente: true,
            comercio: true
          },
          campos: {
            Dni: true,
            Telefono: false,
            Punto_de_venta: false,
            Campo1: false,
            Campo2: false,
            Campo3: false,
            Factura: false
          }
        }
      ],
      listado_terminales_nc: [],
      usuarios_permisos: [],
      nombres: {},

      config: {}
    };
  },

  computed: {},
  mounted: function() {
    $(".box").boxWidget();
    this.terminales();
  },

  methods: {
    add_user_conf() {
      this.usuarios_permisos.push({ n: "user", s: "pass" });
    },

    dell_user_conf(i) {
      this.usuarios_permisos.splice(i, 1);
    },

    save_settings() {
      this.loading = true;

      this.config = {
        nombres: {
          Campo1: this.nombres.Campo1,
          Campo2: this.nombres.Campo2,
          Campo3: this.nombres.Campo3
        },
        terminales: {},
        admins: []
      };

      this.config.admins = this.usuarios_permisos;

      for (let i = 0; i < this.listado_terminales.length; i++) {
        this.config.terminales[this.listado_terminales[i].ter] = {
          trx: this.listado_terminales[i].trx,

          tktImp: {
            cliente: this.listado_terminales[i].tktImp.cliente,
            comercio: this.listado_terminales[i].tktImp.cliente
          },

          campos: this.listado_terminales[i].campos
        };
      }

      this.$http
        .post(
          "SERVER/scd/configs/",
          {
            a: "trxSave",
            t: JSON.stringify(this.config)
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data.status == 1) {
            this.showNotification({
              msj: "Configuración guardada",
              bg: "bg-green"
            });
          } else {
            this.showNotification({
              msj: "Error al guardar la configuración",
              bg: "bg-red"
            });
          }

          this.terminales();
          this.loading = false;
        });
    },

    ver_psw(t) {
      $(t).attr("type", "text");
    },

    hide_psw(t) {
      $(t).attr("type", "password");
    },

    del_ter() {
      if (this.listado_terminales[this.selected_ter].ter != "default") {
        this.listado_terminales_nc.push([
          this.listado_terminales[this.selected_ter].ter,
          this.listado_terminales[this.selected_ter].comercio
        ]);

        this.listado_terminales.splice(this.selected_ter, 1);

        this.selected_ter = 0;
        this.load_ter = 0;
      } else {
        alert("La configuración por defecto no se puede eliminar.");
      }
    },

    add_terminal() {
      if (this.listado_terminales_nc[this.load_ter] != "") {
        this.listado_terminales.push({
          ter: this.listado_terminales_nc[this.load_ter][0],
          comercio: this.listado_terminales_nc[this.load_ter][1],

          campos: {
            Dni: true,
            Telefono: false,
            Punto_de_venta: false,
            Campo1: false,
            Campo2: false,
            Campo3: false,
            Factura: false
          },

          tktImp: {
            cliente: true,
            comercio: true
          },

          trx: {
            Dev: true,
            compra: false,
            compraEC: false,
            anula: false
          }
        });

        this.listado_terminales_nc.splice(this.load_ter, 1);
        this.selected_ter = this.listado_terminales.length - 1;
        this.load_ter = 0;
      }

      $("#ds").css("border-color", "red");

      setTimeout(() => {
        $("#ds").css("border-color", "#d2d6de");
      }, 2000);
    },

    terminales() {
      this.selected_ter = 0;
      this.listado_terminales = [
        {
          ter: "--",
          comercio: "--",
          trx: {
            Dev: true,
            compra: false,
            compraEC: true,
            anula: false
          },
          tktImp: {
            cliente: true,
            comercio: true
          },
          campos: {
            Dni: false,
            Telefono: false,
            Punto_de_venta: false,
            Campo1: false,
            Campo2: false,
            Campo3: false,
            Factura: false
          }
        }
      ];
      this.listado_terminales_nc = [];
      this.usuarios_permisos = [];
      this.nombres = {};
      this.config = {};
      this.load_ter = 0;

      this.loading = true;

      this.$http
        .post(
          "SERVER/scd/configs/",
          {
            a: "trxTer"
          },
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.data[0].status == 1 && response.data[1].status == 1) {
            let ter = [];

            ter[0] = {
              ter: "default",
              campos: response.data[1].data.terminales.default.campos,

              comercio: "--",

              tktImp: response.data[1].data.terminales.default.tktImp,
              trx: response.data[1].data.terminales.default.trx
            };

            for (let i = 0; i < response.data[0].data.length; i++) {
              if (
                response.data[1].data.terminales[response.data[0].data[i][0]] !=
                undefined
              ) {
                ter.push({
                  ter: response.data[0].data[i][0],
                  comercio: response.data[0].data[i][2],
                  campos:
                    response.data[1].data.terminales[
                      response.data[0].data[i][0]
                    ].campos,

                  tktImp:
                    response.data[1].data.terminales[
                      response.data[0].data[i][0]
                    ].tktImp,
                  trx:
                    response.data[1].data.terminales[
                      response.data[0].data[i][0]
                    ].trx
                });
              } else {
                this.listado_terminales_nc.push([
                  response.data[0].data[i][0],
                  response.data[0].data[i][2]
                ]);
              }
            }

            this.usuarios_permisos = response.data[1].data.admins;
            this.nombres = response.data[1].data.nombres;

            this.listado_terminales = ter;
          }

          this.loading = false;
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/configs/trx/main/index.js